import React from 'react';
import { Skeleton } from 'antd';
import { Container, SkeletonCard } from './styles';

const SummarySkeleton = () => (
  <Container>
    {[1, 2, 3, 4, 5, 6, 7].map((index) => (
      <SkeletonCard key={index}>
        <Skeleton active paragraph={{ rows: 1 }} />
      </SkeletonCard>
    ))}
  </Container>
);

export default SummarySkeleton; 